module.exports = __webpack_public_path__ + "img/product_mb_cn_kr.a5d8e43.png";